import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";

const OOPS_M3_Pointers = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
  <ModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="Pointers and Pointer Arithmetic"
    videos={[
      "https://www.youtube.com/embed/kKKvGYAX_Zs",
      "https://www.youtube.com/embed/xHoGGbtFZCo",
      "https://www.youtube.com/embed/TT8_FfPYeW4",
      "https://www.youtube.com/embed/tyOYvb57gtk",
      "https://www.youtube.com/embed/ULxifMAL2XU",
    ]}
    takeaways={[
      {
        text: "Different types of pointers.",
      },
      {
        text: "The main difference between a void pointer and a null pointer.",
      },
      {
        text: "Pointer arithmetic, where they may give code and ask for the value of the pointer or the output of the code.",
      },
      {
        text: "Coding questions will mainly focus on passing pointers to a function.",
      },
      {
        text: "Implementing arrays and strings using pointers (refer to some sources, learn how to implement them, and understand the syntax and logic properly).",
      },
    ]}
    questions={[
      
    ]}
    exampleVideos={[]} // No extra example videos for now
  />
);
}

export default OOPS_M3_Pointers;
